import { memo } from 'react';
import { Button, Divider, Group, Select } from '@mantine/core';
import { FormattedMessage } from 'react-intl';
import { pageSizeOptions } from '../../../../../../global';
import { actionTypes, IInitialState } from '../../../../types';

const PageOffset = ({
  itemsPerPage = 1,
  items = 1,
  page = 1,
}: {
  itemsPerPage?: number;
  items?: number;
  page?: number;
}) => {
  const numberPage = Math.ceil(items / itemsPerPage);
  return (
    <>
      {' '}
      {page} <FormattedMessage id="pagination.pageOf" /> {numberPage}{' '}
    </>
  );
};

const Pagination = memo<any>(
  ({
    dispatch,
    navigation,
    state,
  }: {
    dispatch: (action: any) => void;
    navigation: any;
    state?: IInitialState;
  }) => {
    return (
      <Group
        position="center"
        sx={t => ({
          fontSize: t.fontSizes.sm,
          color: t.colorScheme === 'dark' ? t.colors.dark[1] : t.colors.gray[8],
        })}
      >
        <Group grow={false} position="left">
          <FormattedMessage id="pagination.rows_per_page" defaultMessage="Rows per page" />
          <Select
            style={{ width: '80px' }}
            variant="filled"
            data={
              state?.pageSizeOptions?.map(i => i.toString()) ??
              pageSizeOptions.map(i => i.toString())
            }
            value={state?.itemsPerPage?.toString() || '5'}
            onChange={val => dispatch({ type: actionTypes.SET_ITEMS_PER_PAGE, payload: val })}
          />
        </Group>
        <Divider orientation="vertical" />
        <Group position="center" spacing="xs" grow={false}>
          <Button
            p="xs"
            radius="md"
            size="xs"
            variant="outline"
            disabled={!navigation.previous}
            onClick={() => dispatch({ type: actionTypes.SET_PATH, payload: navigation.first })}
          >
            {'<<'}
          </Button>
          <Button
            p="xs"
            radius="md"
            size="xs"
            variant="outline"
            disabled={!navigation.previous}
            onClick={() => dispatch({ type: actionTypes.SET_PATH, payload: navigation.previous })}
          >
            {'<'}
          </Button>
          <Button
            p="xs"
            radius="md"
            size="xs"
            variant="outline"
            disabled={!navigation.next}
            onClick={() => dispatch({ type: actionTypes.SET_PATH, payload: navigation.next })}
          >
            {'>'}
          </Button>
          <Button
            p="xs"
            radius="md"
            size="xs"
            variant="outline"
            disabled={!navigation.next}
            onClick={() => dispatch({ type: actionTypes.SET_PATH, payload: navigation.last })}
          >
            {'>>'}
          </Button>
        </Group>
        <Divider orientation="vertical" />
        <Group grow={false} position="left">
          <FormattedMessage id="pagination.page" defaultMessage="Page" />
          <PageOffset
            itemsPerPage={state?.itemsPerPage || 5}
            items={navigation.totalItems}
            page={navigation.currentPage}
          />
        </Group>
        <Divider orientation="vertical" />
        <Group grow={false} position="left">
          <FormattedMessage id="pagination.total_items" defaultMessage="Total items" />
          {': '}
          {navigation.totalItems}
        </Group>
      </Group>
    );
  }
);

export default Pagination;
